export default __webpack_public_path__ + "static/media/classroom.7a89ae28.svg";